import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { CategoryDetailPage } from './category-detail.page';
import { SharedModule } from '../../shared-module/shared.module';
import { CategoryDetailPageRoutingModule } from './category-detail-routing.module';

@NgModule({
  imports: [
    FormsModule,
    IonicModule,
    SharedModule,
    CommonModule,
    CategoryDetailPageRoutingModule
  ],
  declarations: [CategoryDetailPage]
})
export class CategoryDetailPageModule {}
